export default {
  // 基础数据-服务类型
  serviceList: "/cms/wenjuan/statistics", // 问卷统计一级菜单列表
  evaluationServiceList: "/cms/wenjuan/getList?pageNo=1&pageSize=10", //概览-服务使用记录(问卷类型)
  evaluationDetail: "/cms/wenjuan/view?serviceId=1", //概览-服务使用记录(问卷类型)-查看按钮-答题详情
};
